import { render } from "./SearchIcon.vue?vue&type=template&id=4bd9139a"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/SearchIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bd9139a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bd9139a', __exports__)) {
    api.reload('4bd9139a', __exports__)
  }
  
  module.hot.accept("./SearchIcon.vue?vue&type=template&id=4bd9139a", () => {
    api.rerender('4bd9139a', render)
  })

}


export default __exports__